<template>
  <div class="wrap">
    <div class="title">入力内容の確認</div>
    <div class="confirm-wrap">
      <div class="row">
        <span>メールアドレス</span>{{ reg.mail }}
      </div>
      <div class="row">
        <span>パスワード</span>{{ maskedPassword }}
      </div>
      <div class="row">
        <span>会社名</span>{{ reg.companyName }}
      </div>
      <div class="row">
        <span>氏名</span>{{ reg.userName }}
      </div>
      <div class="row">
        <span>業種</span>{{ reg.industry }}
      </div>
      <div class="row">
        <span>お知らせの配信</span>{{ reg.receiveNotification ? '配信を希望する' : '配信を希望しない' }}
      </div>
    </div>
    <div class="btn-wrap">
      <button class="btn next-btn" @click="doRegister">
        次へ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Confirm',
  props: {
    reg: Object,
  },
  methods: {
    doRegister() {
      const args = {
        mail: this.reg.mail,
        password: this.reg.password,
        user_name: this.reg.userName,
        company_name: this.reg.companyName,
        industry: this.reg.industry,
        receive_notification: this.reg.receiveNotification,
      }

      this.$store.dispatch('api/createKuraemonId', args).then((res) => {
        if ( this.$store.getters['api/apiError'] ) {
          return;
        }
        console.log(res);
        this.reg.editState = 'confirmed';
        this.$router.replace({ name: 'new-registration-complete' })
      })
    }
  },
  computed: {
    maskedPassword: function () {
      return "*".repeat(this.reg.password.length);
    }
  }
}
</script>

<style scoped>
.wrap {
  padding: 2rem;
  margin: auto;
  width: 500px;
}
.title {
  font-size: 1.4rem;
  font-weight: bold;
  padding-left: 1rem;
  margin-bottom: 1rem;
}
.confirm-wrap {
  padding: 0 1rem;
  margin-top: 4rem;
  margin-bottom: 3rem;
}
.row {
  margin: 1rem 0;
}
.row span {
  font-weight: bold;
  margin-right: 1rem;
}
.btn-wrap {
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.next-btn {
  background-color: #333;
  color: white;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>